// import Component from './index';

export default {
  // component: Component,
  component: load(() => import(/* webpackChunkName: "Test-Stack" */ './index')),
  priority: 9,
  permissions: ['Dashboard'],
  name: 'Stack',
  icon: 'basket',
  drawer: true,
};

